import asyncForever from 'async/forever';
import asyncSeries from 'async/series';
import { createSHA256 } from 'hash-wasm';
import { Sha256 } from 'asmcrypto.js';
import CryptoJS from 'crypto-js';

export default {
  hashFile,
};

const CHUNK_SIZE = 100 * 1024 * 1024;

const g_hashCacheMap = new Map();

function hashFile(file, done) {
  const { webkitRelativePath, lastModified, size } = file;
  const key = webkitRelativePath + '-' + lastModified + '-' + size;
  if (g_hashCacheMap.has(key)) {
    done(null, g_hashCacheMap.get(key));
  } else {
    _internalHashASM(file, (err, hash) => {
      if (!err) {
        g_hashCacheMap.set(key, hash);
      }
      done(err, hash);
    });
  }
}

function _internalHashCryptoJS(file, done) {
  console.log('_internalHashCryptoJS');
  const { size } = file;
  let hash;
  let digest;
  let start_pos = 0;
  asyncSeries(
    [
      (done) => {
        hash = CryptoJS.algo.SHA256.create();
        done();
      },
      (done) => {
        //hash.init();
        asyncForever(
          (done) => {
            const bytes_left = size - start_pos;
            if (bytes_left === 0) {
              done('done');
            } else {
              const block_size = Math.min(CHUNK_SIZE, bytes_left);
              const opts = {
                file: file.slice(start_pos, start_pos + block_size),
                hash,
              };
              _hashBlockCryptoJS(opts, (err) => {
                start_pos += block_size;
                done(err);
              });
            }
          },
          (err) => {
            if (err === 'done') {
              err = null;
            }
            done(err);
          }
        );
      },
      (done) => {
        const result = hash.finalize();
        digest = result.toString(CryptoJS.enc.Hex);
        done();
      },
    ],
    (err) => {
      done(err, digest);
    }
  );
}
function _hashBlockCryptoJS(params, done) {
  const { file, hash } = params;
  const reader = file.stream().getReader();
  asyncForever(
    (done) => {
      reader.read().then(
        (result) => {
          const { value } = result;
          if (value && value.length > 0) {
            const word_array = _cryptoJSFixupAB(value);
            hash.update(word_array);
          }
          done(result.done ? 'done' : null);
        },
        (err) => {
          done(err);
        }
      );
    },
    (err) => {
      if (err === 'done') {
        err = null;
      }
      done(err);
    }
  );
}
function _internalHashASM(file, done) {
  console.log('_internalHashASM');
  const { size } = file;
  let hash;
  let digest;
  let start_pos = 0;
  asyncSeries(
    [
      (done) => {
        hash = new Sha256();
        done();
      },
      (done) => {
        //hash.init();
        asyncForever(
          (done) => {
            const bytes_left = size - start_pos;
            if (bytes_left === 0) {
              done('done');
            } else {
              const block_size = Math.min(CHUNK_SIZE, bytes_left);
              const opts = {
                file: file.slice(start_pos, start_pos + block_size),
                hash,
              };
              _hashBlockASM(opts, (err) => {
                start_pos += block_size;
                done(err);
              });
            }
          },
          (err) => {
            if (err === 'done') {
              err = null;
            }
            done(err);
          }
        );
      },
      (done) => {
        window.hash = hash;
        hash.finish();
        digest = Array.from(hash.result)
          .map(_toHex)
          .join('');
        done();
      },
    ],
    (err) => {
      done(err, digest);
    }
  );
}
function _hashBlockASM(params, done) {
  const { file, hash } = params;
  const reader = file.stream().getReader();
  asyncForever(
    (done) => {
      reader.read().then(
        (result) => {
          const { value } = result;
          if (value && value.length > 0) {
            hash.process(value);
          }
          done(result.done ? 'done' : null);
        },
        (err) => {
          done(err);
        }
      );
    },
    (err) => {
      if (err === 'done') {
        err = null;
      }
      done(err);
    }
  );
}

function _internalHashWASM(file, done) {
  console.log('_internalHashWASM');
  const { size } = file;
  let hash;
  let digest;
  let start_pos = 0;
  asyncSeries(
    [
      (done) => {
        createSHA256().then(
          (result) => {
            hash = result;
            done();
          },
          (err) => {
            done(err);
          }
        );
      },
      (done) => {
        hash.init();
        asyncForever(
          (done) => {
            const bytes_left = size - start_pos;
            if (bytes_left === 0) {
              done('done');
            } else {
              const block_size = Math.min(CHUNK_SIZE, bytes_left);
              const opts = {
                file: file.slice(start_pos, start_pos + block_size),
                hash,
              };
              _hashBlockWASM(opts, (err) => {
                start_pos += block_size;
                done(err);
              });
            }
          },
          (err) => {
            if (err === 'done') {
              err = null;
            }
            done(err);
          }
        );
      },
      (done) => {
        digest = hash.digest('hex');
        done();
      },
    ],
    (err) => {
      done(err, digest);
    }
  );
}
function _hashBlockWASM(params, done) {
  const { file, hash } = params;
  const reader = file.stream().getReader();
  asyncForever(
    (done) => {
      reader.read().then(
        (result) => {
          const { value } = result;
          if (value && value.length > 0) {
            hash.update(value);
          }
          done(result.done ? 'done' : null);
        },
        (err) => {
          done(err);
        }
      );
    },
    (err) => {
      if (err === 'done') {
        err = null;
      }
      done(err);
    }
  );
}
function _toHex(i) {
  return ('0' + i.toString(16)).slice(-2);
}
function _cryptoJSFixupAB(buffer) {
  const temp = [];
  for (var i = 0; i < buffer.length; i += 4) {
    temp.push(
      (buffer[i] << 24) |
        (buffer[i + 1] << 16) |
        (buffer[i + 2] << 8) |
        buffer[i + 3]
    );
  }
  return CryptoJS.lib.WordArray.create(temp, buffer.length);
}
